import { compose } from 'recompose';
import SharedMedia from './sharedMedia';

const enhance = compose();
export default enhance(SharedMedia);
